import _isUndefined from "lodash/isUndefined";
import _isNull from "lodash/isNull";
import _isNumber from "lodash/isNumber";
import _isString from "lodash/isString";
import _isObject from "lodash/isObject";
import _isArray from "lodash/isArray";
import _get from "lodash/get";
import _isFunction from "lodash/isFunction";
import _isEmpty from "lodash/isEmpty";
import _endsWith from "lodash/endsWith";
import { isValidElement, } from "react";
export function isNoneElement(node) {
    return _isUndefined(node) || _isNull(node);
}
export function isTextElement(node) {
    return _isNumber(node) || _isString(node);
}
export function isObjectElement(node) {
    return !isValidElement(node) && _isObject(node) && !_isArray(node);
}
export function isElementOf(node, type) {
    if (isValidElement(node)) {
        const element = node;
        if (element.type === type) {
            return true;
        }
        const displayName = _get(element.type, "displayName");
        if (_isFunction(element.type) &&
            !_isEmpty(displayName) &&
            _endsWith(displayName, _get(type, "displayName"))) {
            return true;
        }
    }
    return false;
}
export const isDef = (val) => val !== undefined && val !== null;
